const marine = {
  id: 'marine',
  displayName: 'Marine',
  enabled: true,
  graph: {
    writeSample: '#54A0FF', writeTrend: '#808080', writeMax: '#4CAF50',
    writeMin: '#FF5722', writeLatency: '#54A0FF',
    readSample: '#00BCD4', readTrend: '#9E9E9E', readMax: '#66BB6A',
    readMin: '#F44336', readLatency: '#00BCD4',
  },
  canvas: {
    chartBg: '#2B2B2B', gridColor: '#444444', textColor: '#ADB5BD',
  },
};
export default marine;
